<template>
  <div>
    <div style="padding:0 15px;">
      <vxe-table
        ref="xTable"
        border
        resizable
        stripe
        highlight-current-row
        row-id="id"
        class="mytable-style"
        :row-class-name="rowClassName"
        :data="tableData"
      >
        <vxe-table-column field="applyStep" title="#" width="40" />
        <vxe-table-column
          field="applyStatus"
          title="审批状态"
          :formatter="formatApplyStatus"
        />
        <vxe-table-column field="applyRoleName" title="审核角色" />
        <vxe-table-column field="applyUserName" title="审核人" />
        <vxe-table-column
          field="applyIsFinished"
          title="决策点"
          width="80"
          :formatter="formatIsFinished"
        />
        <vxe-table-column field="remark" title="备注" />
        <template v-slot:empty>
          <span>
            <p>当前申请无审核流程，系统自动默认审核通过！</p>
          </span>
        </template>
      </vxe-table>
    </div>
    <!-- <InvoiceMessage
      ref="invoiceMessageRef"
      type="audit"
      :latestRecord="sigleInfo"
    ></InvoiceMessage> -->
    <div style="margin-top:20px;display:flex;">
      <div style="margin-bottom:9px;font-weight:bold;margin-left:12px;">
        发票备注
      </div>
      <el-input
        style="width:480px;margin-left:12px;"
        type="textarea"
        :rows="3"
        placeholder="请输入发票备注"
        v-model="remark"
      ></el-input>
    </div>
    <el-form
      v-if="isEite"
      ref="form"
      :rules="rules"
      :model="form"
      label-width="80px"
      style="margin-top:10px;"
    >
      <el-row>
        <el-col :span="24">
          <div class="grid-content bg-purple">
            <el-form-item label="备注" prop="remark" style="margin-right:15px">
              <el-input
                v-model="form.remark"
                type="textarea"
                :rows="6"
                placeholder="请输入"
                maxlength="200"
                show-word-limit
              />
            </el-form-item>
          </div>
        </el-col>
      </el-row>
    </el-form>
    <div v-if="isEite" slot="footer" class="dialog-footer">
      <el-button @click="funcCancel">
        取 消
      </el-button>
      <el-button type="primary" @click="funcReject">
        拒 绝
      </el-button>
      <el-button type="primary" @click="funcPass">
        通 过
      </el-button>
    </div>
  </div>
</template>
<script>
import { editInvoice } from "@/api/invoice";
import request from "@/utils/request";
import InvoiceMessage from "@/components/InvoiceMessage";
export default {
  name: "ReviewRecordEdit",
  components: {
    InvoiceMessage
  },
  props: {
    processType: {
      type: String,
      default: ""
    },
    processApi: {
      type: String,
      default: ""
    },
    sigleInfo: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      isEite: true,
      emptyForm: {},
      tableData: [],
      canSubmit: true,
      form: {
        code: "",
        branchCode: "",
        applyType: "",
        applyFromCode: "",
        applyStep: "",
        applyStatus: "",
        applyRoleCode: "",
        applyUserCode: "",
        applyIsFinished: "",
        remark: ""
      },
      rules: {
        remark: [
          {
            min: 1,
            max: 120,
            message: "长度在 1 到 120 个字符",
            trigger: "blur"
          }
        ]
      },
      remark: "" //发票备注
    };
  },
  watch: {
    sigleInfo: {
      handler(val) {
        this.remark = val.remark;
      },
      deep: true,
      immediate: true
    }
  },
  created() {
    // 保存空表单对象
    this.emptyForm = JSON.parse(JSON.stringify(this.form));
  },
  methods: {
    getEditInvoice() {
      // let ischange = this.$refs.invoiceMessageRef.ischange;
      // let data = this.$refs.invoiceMessageRef.getFormInfo();
      // if (!ischange) {
      //   this.funcSubmit();
      //   return;
      // }
      let data = {
        remark: this.remark,
        code: this.sigleInfo.code
      };
      const rLoading = this.openLoading();
      editInvoice(data)
        .then(res => {
          console.log("editInvoice===", res);
          if (res.status === 0) {
            this.funcSubmit();
          }
          rLoading.close();
        })
        .catch(call => {
          console.log("editInvoice===异常", call);
          rLoading.close();
        });
    },
    // 获取页面信息
    getInfo(code, step) {
      // 查询到数据之前先展示空表单
      this.form = JSON.parse(JSON.stringify(this.emptyForm));
      if (step === -1) {
        this.isEite = false;
      } else {
        this.isEite = true;
        request({
          url: `/ntocc-basic-api/reviewRecord/getOne`,
          method: "get",
          params: {
            applyType: this.processType,
            applyFromCode: code,
            applyStep: step
          }
        }).then(response => {
          if (response.data === void 0) {
            this.$message({
              message: "未找到流程信息，请联系管理员！",
              type: "error"
            });
            this.$emit("fatherAuditMethod");
          } else {
            this.form = response.data;
            if (this.form.applyStatus === 0) {
              this.form.applyStatus = "";
            }
          }
        });
      }

      // 获取审核记录
      request({
        url: `/ntocc-basic-api/reviewRecord/list`,
        method: "get",
        params: {
          applyType: this.processType,
          applyFromCode: code,
          pageNum: 1,
          pageSize: 100,
          sortField: "applyStep",
          sortType: "asc"
        }
      }).then(response => {
        if (response.data !== void 0) {
          this.tableData = response.data;
        }
      });
    },
    // 提交
    funcPass() {
      this.form.applyStatus = 1; // 通过
      this.getEditInvoice();
    },
    funcReject() {
      this.form.applyStatus = 2; // 拒绝
      this.funcSubmit();
    },
    funcSubmit() {
      if (this.canSubmit) {
        this.canSubmit = false;
        this.$refs["form"].validate(valid => {
          if (valid) {
            const data = this.form;
            const rLoading = this.openLoading();
            request({
              url: `/${this.processApi}/audit`,
              method: "put",
              params: data
            }).then(response => {
              rLoading.close();
              this.$message({ message: response.msg, type: "success" });
              this.$emit("fatherAuditMethod");
              const $this = this;
              setTimeout(() => {
                $this.canSubmit = true;
              }, 400);
            });
          } else {
            this.canSubmit = true;
            return false;
          }
        });
      }
    },
    // 取消
    funcCancel() {
      this.$emit("fatherCancelMethod", "audit");
    },
    formatApplyStatus({ cellValue }) {
      switch (cellValue) {
        case 0:
          return "待审核";
        case 1:
          return "已通过";
        case 2:
          return "已拒绝";
        default:
          return "";
      }
    },
    formatIsFinished({ cellValue }) {
      switch (cellValue) {
        case 0:
          return "否";
        case 1:
          return "是";
        default:
          return "";
      }
    },
    rowClassName({ row, rowIndex }) {
      /* if(row.applyStatus===0){
            return 'row-yellow';
        }else */ if (
        row.applyStatus === 1
      ) {
        return "row-green";
      } else if (row.applyStatus === 2) {
        return "row-red";
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.dialog-footer {
  margin: 15px 0 15px 0;
  float: right;
}
.mytable-style ::v-deep .vxe-table--empty-content {
  width: 80%;
  color: #11b95c;
}
</style>
<style>
.mytable-style .vxe-body--row.row-green {
  background-color: #11b95c;
  color: #fff;
}
.mytable-style .vxe-body--row.row-blue {
  background-color: #2db7f5;
  color: #fff;
}
.mytable-style .vxe-body--row.row-red {
  background-color: red;
  color: #fff;
}
.mytable-style .vxe-body--row.row-yellow {
  background-color: #e6a700;
  color: #fff;
}
</style>
